import React, { useState } from 'react';
import styled, { css } from 'styled-components';

import { LinkButton } from '~/components/Buttons';
import { Body, Variant } from '~/components/Typography/index';
import JustificationContainer from '~/components/JustificationContainer';
import FullEmailMessage from '~/components/FullEmailMessage';
import TEST_ID from './index.testid';

const text = {
  showLessButton: 'Toon minder',
  showMoreButton: 'Laat volledige bericht zien',
};
type Props = {
  id: string;
  emailText: string;
  hasMore: boolean;
  canClickOpen: boolean;
};
const EmailEventMessageBlock = ({
  id,
  emailText,
  hasMore,
  canClickOpen,
}: Props) => {
  const [isFullMessageVisible, setFullMessageVisible] = useState(false);

  if (isFullMessageVisible) {
    return (
      <Container direction="column" margin={['s', null, 'm', null]}>
        <MessageContainer data-testid={TEST_ID.FULL_MESSAGE_BLOCK} size="base">
          <FullEmailMessage eventId={id} />
        </MessageContainer>
        <LinkButton
          testId={TEST_ID.HIDE_FULL_MESSAGE_BUTTON}
          onClick={() => setFullMessageVisible(false)}
        >
          {text.showLessButton}
        </LinkButton>
      </Container>
    );
  }

  return (
    <Container direction="column" margin={['s', null, 'm', null]}>
      <MessageContainer
        variant={Variant.primary}
        margin={[null, null, 's', null]}
        data-testid={TEST_ID.MESSAGE_BLOCK}
        size="base"
      >
        <div
          className={'dh-email-container'} // Can safely set it as backend has sanitized it
          dangerouslySetInnerHTML={{
            __html: hasMore ? `${emailText} ...` : emailText,
          }}
        />
      </MessageContainer>

      {canClickOpen && (
        <LinkButton
          testId={TEST_ID.SHOW_FULL_MESSAGE_BUTTON}
          onClick={() => setFullMessageVisible(true)}
        >
          {text.showMoreButton}
        </LinkButton>
      )}
    </Container>
  );
};

const Container = styled(JustificationContainer)<{}>`
  ${() => css`
    word-break: break-word;
  `};
`;

// the min-height is needed to make sure
const MessageContainer = styled(Body)<{}>`
  min-height: 1px;
`;

export default EmailEventMessageBlock;
